import { css } from 'linaria';
import { styled } from 'linaria/react';

export const Container = styled.div`
  margin-bottom: var(--space-25);
`;

export const link = css`
  display: inline !important;
`;
